import { Component, LOCALE_ID, computed, inject, input, output } from '@angular/core';
import { formatDate } from '@angular/common';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import {
    BillingCommitment,
    BillingPlan,
    BillingSubscription,
} from '../../../../../../../Interfaces/api/billing.interface';
import { BILLING_WARNING_STATUSES } from '../../../../../../../Consts/billing.const';

@Component({
    selector: 'app-billing-subscription-card',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './subscription-card.component.html',
    styleUrls: ['../../billing.scss'],
})
export class BillingSubscriptionCardComponent {
    private readonly _locale = inject(LOCALE_ID);

    readonly subscription = input<BillingSubscription | null>(null);
    readonly plan = input<BillingPlan | null>(null);
    readonly commitment = input<BillingCommitment | null>(null);
    readonly isReadOnly = input<boolean>(false);
    readonly isLoading = input<boolean>(false);

    readonly changePlan = output<void>();
    readonly cancel = output<void>();
    readonly resume = output<void>();

    readonly isPendingCancellation = computed<boolean>(() => this.subscription()?.cancel_at_period_end === true);
    readonly isCommitted = computed<boolean>(() => this.commitment()?.is_committed === true);
    readonly isCancellable = computed<boolean>(() => this.commitment()?.is_cancellable !== false);

    readonly statusKey = computed<string>(
        () => `app.billing.subscription.statuses.${this.subscription()?.status ?? 'active'}`,
    );

    readonly isStatusWarning = computed<boolean>(() =>
        BILLING_WARNING_STATUSES.includes(this.subscription()?.status ?? ''),
    );

    readonly lockedUntilParams = computed<Record<string, string>>(() => {
        const opensAt = this.commitment()?.window_opens_at;
        return { date: opensAt ? formatDate(opensAt, 'mediumDate', this._locale) : '' };
    });
}
